import { __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for resource confirmation pages (e.g., after form submission).
 */
export const ResourceConfirmationPayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: safeOptional(z.array(BreadcrumbSchema)),
  }),
);
var __rf=[__zs._zod.innerType.shape["breadcrumbLinks"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_8=__rf[0];
function __vb_11(input){var __bv_3,__bs_4,__bv_5,__bv_6,__bx_7,__bw_9,__bo_10;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_3=input["contentfulRawJsonResponse"];if(!(typeof __bv_3==="object"&&__bv_3!==null&&!Array.isArray(__bv_3)))return __bf_2;__bs_4=__zcPs(__bv_3);__bv_5=input["userLoggedIn"];if(!((__bv_5===undefined||(typeof __bv_5==="boolean"))))return __bf_2;__bv_6=input["breadcrumbLinks"];if(__bv_6===undefined){__bw_9=undefined;}else{__bx_7=__rfn_8(__bv_6);__bw_9=__bx_7;}__bo_10={"contentfulRawJsonResponse":__bs_4};if(__bv_5!==undefined||("userLoggedIn" in input)){__bo_10["userLoggedIn"]=__bv_5;}if(__bw_9!==undefined||("breadcrumbLinks" in input)){__bo_10["breadcrumbLinks"]=__bw_9;}return __bo_10;}
var __rfm_z=__zs.safeParse;
function safeParse_ResourceConfirmationPayloadSchema(input){
var __bd_12=__vb_11(input);
if(__bd_12!==__bf_2){return{success:true,data:__bd_12};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_ResourceConfirmationPayloadSchema,__zs,null,null);
})()

export type ResourceConfirmationPayload = z.infer<typeof ResourceConfirmationPayloadSchema>

export function toResourceConfirmationPayload(payload: unknown): ResourceConfirmationPayload {
  return ResourceConfirmationPayloadSchema.parse(payload)
}
